import { Box, Button, FormControlLabel, Checkbox, TextField, useMediaQuery } from "@mui/material"
import Drawer from "@mui/material/Drawer"
import { Close } from "@mui/icons-material"
import { useCallback, useEffect, useRef } from "react"
import defaultListStore from "src/framework/store/DefaultListStore"
import theme from "src/theme/light"
import { FilterProps } from "../.."

interface FilterDrawerProps {
  isOpened: boolean;
  close: () => void;
  filters: FilterProps
  setFilters: (filters: FilterProps) => void
  handleSearch: () => void
}

const INITIAL_FILTERS_STATE = {
  search: '',
  categoria_ids: [],
  segmentos: [],
}

const FilterDrawer = ({ isOpened, close, filters, setFilters, handleSearch }: FilterDrawerProps) => {
  const cbRef = useRef<any>(null)

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const eventSubmit = useCallback((e: any)=>{
    const cb = (e: any) => cbRef.current(e)
    if (e.keyCode === 13) cb(e)
  },[])

  useEffect(()=>{
    if (isOpened) {
      window.addEventListener('keypress', eventSubmit, true)
    } else {
      window.removeEventListener('keypress', eventSubmit, true)
    }
  },[eventSubmit, isOpened])

  useEffect(()=>{
    cbRef.current = handleSearch
  },[handleSearch])

  const handleChangeSegmentosFilters = useCallback((e)=>{
    const localFilters = { ...filters }
    const value = e.target.checked
    if (value){
      localFilters.segmentos = [...localFilters.segmentos, e.target.name]
      setFilters(localFilters)
      return
    }
    localFilters.segmentos = localFilters.segmentos.filter(segmento => segmento !== e.target.name)
    setFilters(localFilters)
  },[filters, setFilters])
  
  const handleChangeCategoriasFilters = useCallback((e)=>{
    const localFilters = { ...filters }
    const value = e.target.checked
    if (value){
      localFilters.categoria_ids = [...localFilters.categoria_ids, Number(e.target.name)]
      setFilters(localFilters)
      return
    }
    localFilters.categoria_ids = localFilters.categoria_ids.filter(catId => String(catId) !== e.target.name)
    setFilters(localFilters)
  },[filters, setFilters])


  return (
    <Drawer PaperProps={{ style: { width: 286 }}} anchor="right" open={isOpened} onClose={close}>
        <Box paddingLeft={'10px'} style={{ display: "flex", justifyContent: isMobile ? "flex-end" : "flex-start" }} >
          <Button
              variant="text"
              color="primary"
              startIcon={<Close />}
              style={{marginTop: 10, marginBottom: isMobile ? 10 : 50}}
              onClick={close}
              >
              {isMobile ? '' : 'Fechar'}
          </Button>
        </Box>

        <Box flex={1} padding={2} alignItems='flex-start' display='flex' flexDirection={'column'}>
          <span style={{ color: theme.palette.primary.main, fontSize: 18, fontWeight: 600, marginBottom: 12 }} >Categoria</span>
          {defaultListStore?.categoriasBibliotecas?.map((categoria) => (
            <FormControlLabel
              control={<Checkbox checked={!!filters.categoria_ids.find(item => item === categoria.id)} color='primary' onChange={handleChangeCategoriasFilters} name={String(categoria.id)} />}
              label={categoria.nome}
            />
          ))}

          <span style={{ color: theme.palette.primary.main, fontSize: 18, marginTop: 36, fontWeight: 600, marginBottom: 12 }} >Segmento</span>
          <FormControlLabel
            control={<Checkbox checked={!!filters.segmentos.find(item => item === 'on')} color='primary' onChange={handleChangeSegmentosFilters} name="on" />}
            label={"On Grid"}
          />
          <FormControlLabel
            control={<Checkbox checked={!!filters.segmentos.find(item => item === 'off')} color='primary' onChange={handleChangeSegmentosFilters} name="off" />}
            label={"Off Grid"}
          />
          <FormControlLabel
            control={<Checkbox checked={!!filters.segmentos.find(item => item === 'todos')} color='primary' onChange={handleChangeSegmentosFilters} name="todos" />}
            label={"Ambos"}
          />

          <TextField
            fullWidth
            style={{marginTop: 20}}
            label="Busca por palavra-chave"
            variant="outlined"
            value={filters.search}
            onChange={e => {
              const localFilters = {...filters}
              localFilters.search = e.target.value
              setFilters(localFilters)
            }} 
          />
        </Box>

        <Box height={isMobile ? '150px' : '75px'} p={2} marginTop={'10px'} width={'100%'} display='flex' flexDirection={isMobile ? "column-reverse" : "row"} justifyContent={isMobile ? undefined : 'flex-end'}>
          <Button onClick={() => setFilters(INITIAL_FILTERS_STATE)} style={{marginRight: isMobile ? 0 : '10px' }}  color="primary" variant="outlined">Limpar filtros</Button>
          <Button onClick={handleSearch} style={{ marginBottom: isMobile ? "10px" : 0 }}  color="primary" variant="contained">Buscar</Button>
        </Box>

      </Drawer>
  )
}

export { FilterDrawer }